<div class="me-2 preview_window">
  <div class="name_label color_title mt-3">Native Preview</div>
  <div class="creative_display">
    <mat-tab-group>
      <mat-tab label="Social Feed">
        <mat-card class="custom-card">
          <div class="native-vertical-card">
            <div class="ad-label">Ad</div>

            <div class="top-section">
              <img
                class="avatar"
                [attr.src]="
                  adType != 'native_video_content_vast_vpaid_wrapper'
                    ? nativeOfferDetails.logo_preview_url
                    : null
                "
                [style.visibility]="
                  adType == 'native_video_content_vast_vpaid_wrapper'
                    ? 'hidden'
                    : ''
                "
                alt="avatar"
              />
              <div class="title">{{ nativeOfferDetails.title_short }}</div>
            </div>

            <img class="main-image" [src]="previewNativeImg" alt="preview" />
            <div
              *ngIf="adType != 'native_image_content'"
              class="play-icon"
              matTooltip="When an ad is served, clicking the play icon will start the video."
            >
              <mat-icon>play_arrow</mat-icon>
            </div>

            <button class="cta-button">
              {{ nativeOfferDetails.call_to_action }}
            </button>
          </div>
        </mat-card>
      </mat-tab>

      <mat-tab label="Content Feed">
        <div class="native-ad-card">
          <div class="ad-label">Ad</div>

          <div class="native-content">
            <img
              [style.visibility]="
                adType == 'native_video_content_vast_vpaid_wrapper'
                  ? 'hidden'
                  : ''
              "
              alt="avatar"
              [src]="nativeOfferDetails.logo_preview_url"
              alt="Thumbnail"
              class="native-thumb"
            />

            <div class="native-text">
              <div class="native-title">
                {{ nativeOfferDetails.title_short }}
              </div>
              <div class="native-description">
                {{ nativeOfferDetails.description_short }}
              </div>
              <a class="native-cta">{{
                nativeOfferDetails.call_to_action
              }}</a>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
